<template>
  <div id="app">
    <div class="loading" v-if="loading">
      <div class="la-ball-running-dots">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <siteHeader/>
    <div>
      <div class="w3-sidebar w3-bar-block w3-collapse w3-animate-left" id="appSidebar">
        <router-link to="/" exact class="w3-bar-item logo" v-on:click.native="closeMenu()">
          <!-- <span class="logo1">Daytona</span><span class="logo2">Local</span> -->
          <img src="./assets/logo.png" style="height:40px; margin:-4px 0 0 0" />
        </router-link>
        <router-link to="/" exact class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="home" class="menuIcon"></font-awesome-icon>Home
        </router-link>
        <!-- <router-link to="/news" class="w3-bar-item w3-button menuLink" :class="$route.name === 'news-details' ? 'router-link-active' : ''" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="newspaper" class="menuIcon"></font-awesome-icon>News
        </router-link> -->
        <router-link to="/events" class="w3-bar-item w3-button menuLink" :class="$route.name === 'event-details' ? 'router-link-active' : ''" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="calendar" class="menuIcon"></font-awesome-icon>Events
        </router-link>
        <router-link to="/attractions" class="w3-bar-item w3-button menuLink" :class="$route.name === 'attraction-details' ? 'router-link-active' : ''" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="map" class="menuIcon"></font-awesome-icon>Attractions
        </router-link>
        <router-link to="/parks" class="w3-bar-item w3-button menuLink" :class="$route.name === 'route-details' ? 'router-link-active' : ''" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="tree" class="menuIcon"></font-awesome-icon>Parks
        </router-link>
        <router-link to="/dining" class="w3-bar-item w3-button menuLink" :class="$route.name === 'restaurant-details' ? 'router-link-active' : ''" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="utensils" class="menuIcon"></font-awesome-icon>Dining
        </router-link>
        <router-link to="/organizers" class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="briefcase" class="menuIcon"></font-awesome-icon>Organizers
        </router-link>
        <router-link to="/advertisers" class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="chart-line" class="menuIcon"></font-awesome-icon>Advertisers
        </router-link>
        <router-link to="/submit-event" class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="calendar-plus" class="menuIcon"></font-awesome-icon>Submit Event
        </router-link>
        <router-link to="/support" class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
          <font-awesome-icon icon="info-circle" class="menuIcon"></font-awesome-icon>Support
        </router-link>
        <div v-if="user">
          <router-link to="/admin" v-if="user.email === 'darren@gomobile7.com'" class="w3-bar-item w3-button menuLink" v-on:click.native="closeMenu()">
            <font-awesome-icon icon="user-shield" class="menuIcon"></font-awesome-icon>Admin
          </router-link>
        </div>
      </div>
      <div class="w3-main">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import siteHeader from '@/components/siteHeader.vue'
  import userauth from '@/components/userauth.vue'
  import { mapState } from 'vuex';

  export default {
    name: "App",
    computed: mapState([
      'user',
      'loading'
    ]),
    components: {
      siteHeader,
      userauth
    },
    methods: {
      closeMenu() {
        window.scrollTo(0, 0)
        document.getElementById("appSidebar").style.display = "none"
      }
    },
    created() {
      this.$store.commit('setLoading', false)
    }
  }
</script>

<style>
/* @import url('https://fonts.googleapis.com/css?family=Roboto:300,500,700|Cabin:400,700|Lato:300,400,700|Montserrat:400'); */
/* @import "./assets/spectre.min.css"; */
@import "./assets/grid.css";
@import "./assets/w3pro.css";
@import "./assets/style.css";
@import "./assets/spinner.css";

@font-face {
  font-family: 'fa-solid';
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url("./assets/fonts/fa-solid.ttf");
}
@font-face {
  font-family: 'fa-regular';
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url("./assets/fonts/fa-regular.ttf");
}
/* mulish-300 - latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 300;
  src: local(''),
       url('./assets/fonts/mulish-v1-latin-300.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/mulish-v1-latin-300.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* mulish-regular - latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  src: local(''),
       url('./assets/fonts/mulish-v1-latin-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/mulish-v1-latin-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* mulish-700 - latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  src: local(''),
       url('./assets/fonts/mulish-v1-latin-700.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/mulish-v1-latin-700.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* mulish-900 - latin */
@font-face {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 900;
  src: local(''),
       url('./assets/fonts/mulish-v1-latin-900.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/mulish-v1-latin-900.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* roboto-300 - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  src: local('Roboto Light'), local('Roboto-Light'),
       url('./assets/fonts/roboto-v20-latin-300.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/roboto-v20-latin-300.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* roboto-regular - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  src: local('Roboto'), local('Roboto-Regular'),
       url('./assets/fonts/roboto-v20-latin-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/roboto-v20-latin-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* roboto-500 - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  src: local('Roboto Medium'), local('Roboto-Medium'),
       url('./assets/fonts/roboto-v20-latin-500.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/roboto-v20-latin-500.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* roboto-700 - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  src: local('Roboto Bold'), local('Roboto-Bold'),
       url('./assets/fonts/roboto-v20-latin-700.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('./assets/fonts/roboto-v20-latin-700.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

</style>
